import CanvasRunner from "../../Runtime/CanvasRunner";
import withEnv from "./withEnv";

const Step = ({ project, processId, onBack }) => (
  <CanvasRunner project={project} process={{ id: processId }} onBack={onBack} />
);

export default withEnv(Step);
